import { BaseEntityDTO, IBaseEntityDTO } from './base.entity.dto';

export interface IEmailTemplateDTO extends IBaseEntityDTO {
  subject: string;
  htmlBody: string;
  textBody: string;
  from: string;
}

export class EmailTemplateDTO extends BaseEntityDTO implements IEmailTemplateDTO {
  subject: string;
  htmlBody: string;
  textBody: string;
  from: string;

  constructor(data?: Partial<EmailTemplateDTO>) {
    super();
    if (data) {
      Object.assign(this, data);
    }
    this.subject = data?.subject ?? '';
    this.htmlBody = data?.htmlBody ?? '';
    this.textBody = data?.textBody ?? '';
    this.from = data?.from ?? '';
  }
}
